import { render, staticRenderFns } from "./Prefecture.vue?vue&type=template&id=a546066c&scoped=true&"
import script from "./Prefecture.vue?vue&type=script&lang=js&"
export * from "./Prefecture.vue?vue&type=script&lang=js&"
import style0 from "./Prefecture.vue?vue&type=style&index=0&id=a546066c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a546066c",
  null
  
)

export default component.exports